/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateSupplierDto } from '../models/work-create-supplier-dto';
import { WorkDocument } from '../models/work-document';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkLindasImportsResultsDto } from '../models/work-lindas-imports-results-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkSupplier } from '../models/work-supplier';
import { WorkUpdateSupplierDto } from '../models/work-update-supplier-dto';
import { WorkUpdateSupplierFromLindasDto } from '../models/work-update-supplier-from-lindas-dto';

@Injectable({ providedIn: 'root' })
export class WorkSuppliersV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `suppliersV2ControllerGetAllDropdownOptions()` */
  static readonly SuppliersV2ControllerGetAllDropdownOptionsPath = '/v2/suppliers/dropdown-options';

  /**
   * Required permissions: suppliers:read, suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: suppliers:read, suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.suppliersV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `suppliersV2ControllerGetAllDropdownOptionsForZipcode()` */
  static readonly SuppliersV2ControllerGetAllDropdownOptionsForZipcodePath = '/v2/suppliers/dropdown-options/{zipcode}';

  /**
   * Required permissions: suppliers:read, suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerGetAllDropdownOptionsForZipcode()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerGetAllDropdownOptionsForZipcode$Response(
    params: {
      zipcode: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerGetAllDropdownOptionsForZipcodePath, 'get');
    if (params) {
      rb.path('zipcode', params.zipcode, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: suppliers:read, suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerGetAllDropdownOptionsForZipcode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerGetAllDropdownOptionsForZipcode(
    params: {
      zipcode: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.suppliersV2ControllerGetAllDropdownOptionsForZipcode$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `suppliersV2ControllerFindAllPaginated()` */
  static readonly SuppliersV2ControllerFindAllPaginatedPath = '/v2/suppliers/paginated';

  /**
   * Required permissions: suppliers:read, suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by zipcode query param.
     *           <p>
     *              <b>Format: </b> filter.zipcode={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.zipcode=$not:$like:John Doe&filter.zipcode=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.zipcode'?: Array<string>;

    /**
     * Filter by city query param.
     *           <p>
     *              <b>Format: </b> filter.city={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.city=$not:$like:John Doe&filter.city=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.city'?: Array<string>;

    /**
     * Filter by canton query param.
     *           <p>
     *              <b>Format: </b> filter.canton={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.canton=$not:$like:John Doe&filter.canton=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.canton'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>zipcode</li>
     * <li>city</li>
     * <li>street</li>
     * <li>canton</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'zipcode:ASC' | 'zipcode:DESC' | 'city:ASC' | 'city:DESC' | 'street:ASC' | 'street:DESC' | 'canton:ASC' | 'canton:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,zipcode,city,street,canton
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>zipcode</li>
     * <li>city</li>
     * <li>street</li>
     * <li>canton</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkSupplier>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'zipcode'?: (string | Array<string>);
'city'?: (string | Array<string>);
'canton'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.zipcode', params['filter.zipcode'], {});
      rb.query('filter.city', params['filter.city'], {});
      rb.query('filter.canton', params['filter.canton'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkSupplier>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'zipcode'?: (string | Array<string>);
        'city'?: (string | Array<string>);
        'canton'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: suppliers:read, suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by zipcode query param.
     *           <p>
     *              <b>Format: </b> filter.zipcode={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.zipcode=$not:$like:John Doe&filter.zipcode=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.zipcode'?: Array<string>;

    /**
     * Filter by city query param.
     *           <p>
     *              <b>Format: </b> filter.city={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.city=$not:$like:John Doe&filter.city=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.city'?: Array<string>;

    /**
     * Filter by canton query param.
     *           <p>
     *              <b>Format: </b> filter.canton={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.canton=$not:$like:John Doe&filter.canton=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.canton'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>zipcode</li>
     * <li>city</li>
     * <li>street</li>
     * <li>canton</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'zipcode:ASC' | 'zipcode:DESC' | 'city:ASC' | 'city:DESC' | 'street:ASC' | 'street:DESC' | 'canton:ASC' | 'canton:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,zipcode,city,street,canton
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>zipcode</li>
     * <li>city</li>
     * <li>street</li>
     * <li>canton</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkSupplier>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'zipcode'?: (string | Array<string>);
'city'?: (string | Array<string>);
'canton'?: (string | Array<string>);
};
};
}> {
    return this.suppliersV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkSupplier>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'zipcode'?: (string | Array<string>);
'city'?: (string | Array<string>);
'canton'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkSupplier>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'zipcode'?: (string | Array<string>);
'city'?: (string | Array<string>);
'canton'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `suppliersV2ControllerGetImportPreviewAsCsv()` */
  static readonly SuppliersV2ControllerGetImportPreviewAsCsvPath = '/v2/suppliers/getImportPreviewAsCsv';

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerGetImportPreviewAsCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerGetImportPreviewAsCsv$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerGetImportPreviewAsCsvPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerGetImportPreviewAsCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerGetImportPreviewAsCsv(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.suppliersV2ControllerGetImportPreviewAsCsv$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `suppliersV2ControllerFindOneById()` */
  static readonly SuppliersV2ControllerFindOneByIdPath = '/v2/suppliers/{id}';

  /**
   * Required permissions: suppliers:read, suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerFindOneById$Response(
    params: {
      id: number;
      withProjects?: boolean;
      withPowermemberships?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSupplier>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('withProjects', params.withProjects, {});
      rb.query('withPowermemberships', params.withPowermemberships, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSupplier>;
      })
    );
  }

  /**
   * Required permissions: suppliers:read, suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerFindOneById(
    params: {
      id: number;
      withProjects?: boolean;
      withPowermemberships?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkSupplier> {
    return this.suppliersV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSupplier>): WorkSupplier => r.body)
    );
  }

  /** Path part for operation `suppliersV2ControllerDelete()` */
  static readonly SuppliersV2ControllerDeletePath = '/v2/suppliers/{id}';

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.suppliersV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `suppliersV2ControllerUpdate()` */
  static readonly SuppliersV2ControllerUpdatePath = '/v2/suppliers/{id}';

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  suppliersV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateSupplierDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSupplier>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSupplier>;
      })
    );
  }

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  suppliersV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateSupplierDto
    },
    context?: HttpContext
  ): Observable<WorkSupplier> {
    return this.suppliersV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSupplier>): WorkSupplier => r.body)
    );
  }

  /** Path part for operation `suppliersV2ControllerCreate()` */
  static readonly SuppliersV2ControllerCreatePath = '/v2/suppliers';

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  suppliersV2ControllerCreate$Response(
    params: {
      body: WorkCreateSupplierDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSupplier>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSupplier>;
      })
    );
  }

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  suppliersV2ControllerCreate(
    params: {
      body: WorkCreateSupplierDto
    },
    context?: HttpContext
  ): Observable<WorkSupplier> {
    return this.suppliersV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSupplier>): WorkSupplier => r.body)
    );
  }

  /** Path part for operation `suppliersV2ControllerUpdateFromLindas()` */
  static readonly SuppliersV2ControllerUpdateFromLindasPath = '/v2/suppliers/update-from-lindas';

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerUpdateFromLindas()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  suppliersV2ControllerUpdateFromLindas$Response(
    params: {
      confirm?: boolean;
      body: WorkUpdateSupplierFromLindasDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkLindasImportsResultsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerUpdateFromLindasPath, 'post');
    if (params) {
      rb.query('confirm', params.confirm, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkLindasImportsResultsDto>;
      })
    );
  }

  /**
   * Required permissions: suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerUpdateFromLindas$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  suppliersV2ControllerUpdateFromLindas(
    params: {
      confirm?: boolean;
      body: WorkUpdateSupplierFromLindasDto
    },
    context?: HttpContext
  ): Observable<WorkLindasImportsResultsDto> {
    return this.suppliersV2ControllerUpdateFromLindas$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkLindasImportsResultsDto>): WorkLindasImportsResultsDto => r.body)
    );
  }

  /** Path part for operation `suppliersV2ControllerGetDocumentsBySupplierId()` */
  static readonly SuppliersV2ControllerGetDocumentsBySupplierIdPath = '/v2/suppliers/{id}/documents';

  /**
   * Required permissions: suppliers:read, suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerGetDocumentsBySupplierId()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerGetDocumentsBySupplierId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerGetDocumentsBySupplierIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: suppliers:read, suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerGetDocumentsBySupplierId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerGetDocumentsBySupplierId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.suppliersV2ControllerGetDocumentsBySupplierId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `suppliersV2ControllerAddDocumentToSupplier()` */
  static readonly SuppliersV2ControllerAddDocumentToSupplierPath = '/v2/suppliers/{id}/documents/{documentId}';

  /**
   * Required permissions: suppliers:update, suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerAddDocumentToSupplier()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerAddDocumentToSupplier$Response(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocument>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerAddDocumentToSupplierPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('documentId', params.documentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocument>;
      })
    );
  }

  /**
   * Required permissions: suppliers:update, suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerAddDocumentToSupplier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerAddDocumentToSupplier(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<WorkDocument> {
    return this.suppliersV2ControllerAddDocumentToSupplier$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocument>): WorkDocument => r.body)
    );
  }

  /** Path part for operation `suppliersV2ControllerRemoveDocumentFromSupplier()` */
  static readonly SuppliersV2ControllerRemoveDocumentFromSupplierPath = '/v2/suppliers/{id}/documents/{documentId}';

  /**
   * Required permissions: suppliers:update, suppliers:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suppliersV2ControllerRemoveDocumentFromSupplier()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerRemoveDocumentFromSupplier$Response(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSuppliersV2Service.SuppliersV2ControllerRemoveDocumentFromSupplierPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('documentId', params.documentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: suppliers:update, suppliers:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `suppliersV2ControllerRemoveDocumentFromSupplier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  suppliersV2ControllerRemoveDocumentFromSupplier(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.suppliersV2ControllerRemoveDocumentFromSupplier$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
